import { escapeHtml } from "containers/admin/clients/client/theme-configuration-page/theme-preview/theme-preview.helpers";

import {
  BASE_FONT_STACK,
  FIGTREE_STYLESHEET_URL,
} from "containers/admin/clients/client/theme-configuration-page/theme-preview/theme-preview.constants";

type PreviewDocumentArgs = {
  body: string;
  styles: string;
  isBaseFontApplied: boolean;
  /** The theme's own web fonts; the document is isolated from the app, so it loads them itself. */
  fontStylesheets?: string[];
};

const DOCUMENT_STYLES = `
  :root {
    --preview-font-family: 'Figtree', sans-serif;
    --preview-text-primary: #111827;
    --preview-text-secondary: #4b5563;
    --preview-border: #e5e7eb;
    --preview-surface: #ffffff;
    --preview-surface-muted: #f3f4f6;
    --preview-button: #4b5563;
    --preview-button-text: #ffffff;
  }
  *, *::before, *::after { box-sizing: border-box; }
  html, body { margin: 0; }
  body {
    font-family: var(--preview-font-family);
    color: var(--preview-text-primary);
    background: var(--preview-surface);
    -webkit-font-smoothing: antialiased;
  }
  h1, h2, h3, p, ul { margin: 0; }
  .button {
    display: inline-flex;
    align-items: center;
    padding: 8px 16px;
    border-radius: 6px;
    background: var(--preview-button);
    color: var(--preview-button-text);
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.05));
  }
  .link { font-weight: 600; text-decoration: underline; }
`;

/**
 * The whole document the preview iframe renders. It is static and script-free: the iframe is sandboxed
 * with no permissions, so nothing in it can run, submit or navigate.
 */
export const buildPreviewDocument = ({
  body,
  styles,
  isBaseFontApplied,
  fontStylesheets = [],
}: PreviewDocumentArgs) => `<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    ${[FIGTREE_STYLESHEET_URL, ...fontStylesheets]
      .map((url) => `<link rel="stylesheet" href="${escapeHtml(url)}" />`)
      .join("\n    ")}
    <style>${DOCUMENT_STYLES}${styles}</style>
    ${isBaseFontApplied ? `<style>:root { --preview-font-family: ${BASE_FONT_STACK}; }</style>` : ""}
  </head>
  <body>${body}</body>
</html>`;
